import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Input } from 'components/Shared';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FORM_BACK_ACTION } from 'constants/Common';
import { ListVehicleTypesActions as ListTypes } from 'store/ducks/vehicleTypes';
import type { AppDispatch, RootState } from 'store';
import { CreateVehicleTypeActions as CreateActions } from 'store/ducks/vehicleTypes';
import { CreateVehicleTypeValidator } from 'validators/VehicleTypes';
import * as S from './styles';

interface Props {
  onCreate?: () => void;
}

export const VehicleTypeCreationForm: React.FC<Props> = ({ onCreate }) => {
  const dispatch: AppDispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors, handleApiErrors } = useValidation();

  const { loading: creatingVehicleType, validationErrors } = useSelector(
    (state: RootState) => state.createVehicleType
  );

  const fetchListTypes = useCallback((): void => {
    dispatch(ListTypes.request());
  }, []);

  const onSuccess = useCallback((): void => {
    formRef?.current?.reset();
    onCreate && onCreate();
  }, [onCreate]);

  const onSubmit = useCallback(
    async (data: any): Promise<void> => {
      try {
        formRef?.current?.setErrors({});
        const { schema } = new CreateVehicleTypeValidator();

        const validData = await schema.validate(data, {
          abortEarly: false,
        });

        dispatch(CreateActions.request(validData, onSuccess));
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [dispatch, handleFormErrors, onSuccess]
  );

  useEffect(() => {
    fetchListTypes();
  }, []);

  useEffect(() => {
    handleApiErrors(validationErrors, formRef);
  }, [handleApiErrors, validationErrors]);

  useEffect(() => {
    return () => {
      dispatch(CreateActions.reset());
    };
  }, [dispatch]);

  return (
    <S.MainPanel>
      <S.Content>
        <Form ref={formRef} onSubmit={onSubmit}>
          <S.FormRowCreate>
            <Input name="name" label="Tipo de Veículo" />
            <Input
              name="pallet_padrao"
              label="Pallet Padrão"
              type="number"
              min="1"
              max="99"
            />
            <Input
              name="pallet_remontado"
              label="Pallet Remontado"
              type="number"
              min="1"
              max="99"
            />
            <Input
              name="peso_maximo"
              label="Peso Máximo"
              type="number"
              min="1"
              max="99999"
            />
          </S.FormRowCreate>
          <S.FormActions>
            <S.LinkButton mood="light" to="/configuracoes/tipos-veiculo">
              {FORM_BACK_ACTION}
            </S.LinkButton>
            <S.Button type="submit">
              {creatingVehicleType ? <S.ActivityIndicator /> : 'Salvar'}
            </S.Button>
          </S.FormActions>
        </Form>
      </S.Content>
    </S.MainPanel>
  );
};
